export default __webpack_public_path__ + "static/studio-871bb645b1b2ede8894edd28dab2d638.webp";